import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface BetaInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const BOOK_A_TIME_URL =
  'https://outlook.office.com/book/bookings-CustomerDiscoveryChats@eppendorf.com/?ismsaljsauthenabled';
const SHARE_FEEDBACK_URL = 'https://eppendorf.qualtrics.com/jfe/form/SV_0jNlRpXZoh3vqeO';

export function BetaInfoDialog({ isOpen, onClose }: BetaInfoDialogProps): ReactElement {
  const { t } = useTranslation();

  return (
    <Dialog isOpen={isOpen} onOpenChange={onClose} className="w-max-4xl">
      <div className="flex flex__ai--center gap-m m-bottom-xxl">
        <Icon name="records" size={IconSizeClasses.Medium} className="bg-purple-500" />
        <Dialog.Title className="m-bottom-none">
          {t('reportHub.beta.dialogTitle')}
        </Dialog.Title>
      </div>
      <Dialog.Description />

      <div className="flex flex__dir--column gap-xl font-size-m">
        <p>
          <Trans
            i18nKey="reportHub.beta.dialogDescription"
            components={{ bold: <span className="font-weight-bold" /> }}
          />{' '}
          {t('reportHub.beta.dialogFeedbackIntro')}
        </p>

        <div
          className="flex border-solid border-s border-color-blue-500 border-radius-l"
          style={{ backgroundColor: '#eef1fb' }}
        >
          <div
            className="flex flex__dir--column flex__ai--center gap-m p-l"
            style={{ flex: 1 }}
          >
            <p className="text-align-center">{t('reportHub.beta.dialogBookCallLabel')}</p>
            <a href={BOOK_A_TIME_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="primary">
                {t('reportHub.beta.dialogBookCallButton')}
                <Icon
                  name="external-link"
                  size={IconSizeClasses.XSmall}
                  className="bg-white m-left-s"
                />
              </Button>
            </a>
          </div>
          <div className="flex flex__ai--center p-top-l p-bottom-l">
            <div style={{ width: '1px', height: '100%', backgroundColor: '#b9bdc4' }} />
          </div>
          <div
            className="flex flex__dir--column flex__ai--center gap-m p-l"
            style={{ flex: 1 }}
          >
            <p className="text-align-center">
              {t('reportHub.beta.dialogShareFeedbackLabel')}
            </p>
            <a href={SHARE_FEEDBACK_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="primary">
                {t('reportHub.beta.dialogShareFeedbackButton')}
                <Icon
                  name="external-link"
                  size={IconSizeClasses.XSmall}
                  className="bg-white m-left-s"
                />
              </Button>
            </a>
          </div>
        </div>

        <div
          className="border-solid border-s border-radius-l p-l"
          style={{ backgroundColor: '#f8f9fa', borderColor: '#b9bdc4' }}
        >
          <p>
            <Trans
              i18nKey="reportHub.beta.dialogNotice"
              components={{ bold: <span className="font-weight-bold" /> }}
            />
          </p>
        </div>
      </div>

      <Dialog.Actions>
        <Button variant="secondary" onClick={onClose}>
          {t('shared.close')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
